var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "span",
      {
        staticStyle: {
          "margin-right": "5px",
          "text-decoration": "underline",
          cursor: "pointer",
        },
        on: {
          click: function ($event) {
            return _vm.getSimilarModels(_vm.rowData[_vm.fieldData.fieldCode])
          },
        },
      },
      [_vm._v("查看相似款")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }